import { render } from "./MultiselectChoices.vue?vue&type=template&id=20af9bc8&scoped=true"
import script from "./MultiselectChoices.vue?vue&type=script&lang=js"
export * from "./MultiselectChoices.vue?vue&type=script&lang=js"

import "./MultiselectChoices.vue?vue&type=style&index=0&id=20af9bc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20af9bc8"]])

export default __exports__